import { Injectable } from '@angular/core';
import {
  AccessPermission,
  AdFormatType,
  AdFormatTypeLabels,
  Carrier,
  CarrierLabels,
  Contents,
  DebugMode,
  DeliveryControlDrawMethod,
  DeliveryControlDrawMethodLabels,
  DeliveryControlType,
  DeliveryControlTypeLabels,
  DeliveryScope,
  DeliveryScopeLabels,
  DeliverySetCondition,
  DeliverySetConditionLabels,
  DeliverySetConditionSearchConvert,
  DeliverySetConditionSearchIndex,
  DeliverySetConditionSearchLabels,
  DeliverySetLpOpenMethod,
  DeliverySetLpOpenMethodLabels,
  DeliverySetSearchStatusConvertFromDBCodeToScreenDisplayOrder,
  DeliverySetStatus,
  DeliverySetStatusLabels,
  DeliverySetStatusSearchConvertFromScreenDisplayOrderToDBCode,
  DeliverySetStatusSearchIndex,
  DeliverySetStatusSearchLabels,
  DesignTemplateAssetType,
  DesignTemplateAssetTypeLabels,
  DesignTemplatePreviewModalReplaces,
  DesignTemplateType,
  DesignTemplateTypeLabels,
  EnableAutomaticRatio,
  FloorPriceOptimize,
  FloorPriceOptimizeLabels,
  MaintenanceStatus,
  MaintenanceStatusLabels,
  MediaType,
  MediaTypeLabels,
  MediaTypeAppLabels,
  MediaTypeSearchConvert,
  MediaTypeSearchIndex,
  MediaTypeSearchLabels,
  NextAction,
  OSGroupSetting,
  PlacementAssetDisplayType,
  PlacementAssetDisplayTypeLabels,
  PlacementAssetTapType,
  PlacementAssetTapTypeLabels,
  PlacementAssetType,
  PlacementAssetTypeLabels,
  PlacementHasAsset,
  PlacementSearchMode,
  PLATFORM_PASSBACK_ID,
  PlatformDeliveryType,
  PlatformDeliveryTypeLabels,
  SDKVersionGroupSetting,
  UserRoleCondition,
  UserRoleConditionLabels,
  UserStatus,
  UserStatusCondition,
  UserStatusConditionLabels,
  FloatingSettingSearchType,
  PlatformReservationStatus,
  CheckBoxPlatformDeliverType,
  DeliverySetTesterCondition,
  DeliverySetTesterConditionLabels
} from '../constants';

@Injectable({ providedIn: 'root' })
export class ConstantsService {
  public get DeliverySetStatusSearchConvertFromScreenDisplayOrderToDBCode() {
    return DeliverySetStatusSearchConvertFromScreenDisplayOrderToDBCode;
  }
  public get DeliverySetSearchStatusConvertFromDBCodeToScreenDisplayOrder() {
    return DeliverySetSearchStatusConvertFromDBCodeToScreenDisplayOrder;
  }
  public get DeliverySetStatus() { return DeliverySetStatus; }
  public get DeliverySetStatusLabels() { return DeliverySetStatusLabels; }
  public get DeliverySetStatusSearchIndex() { return DeliverySetStatusSearchIndex; }
  public get DeliverySetStatusSearchLabels() { return DeliverySetStatusSearchLabels; }
  public get DeliverySetConditionSearchConvert() { return DeliverySetConditionSearchConvert; }
  public get DeliverySetCondition() { return DeliverySetCondition; }
  public get DeliverySetConditionLabels() { return DeliverySetConditionLabels; }
  public get DeliverySetConditionSearchIndex() { return DeliverySetConditionSearchIndex; }
  public get DeliverySetConditionSearchLabels() { return DeliverySetConditionSearchLabels; }
  public get DeliverySetLpOpenMethod() { return DeliverySetLpOpenMethod; }
  public get DeliverySetLpOpenMethodLabels() { return DeliverySetLpOpenMethodLabels; }
  public get DeliveryControlType() { return DeliveryControlType; }
  public get DeliveryControlTypeLabels() { return DeliveryControlTypeLabels; }
  public get DeliveryControlDrawMethod() { return DeliveryControlDrawMethod; }
  public get DeliveryControlDrawMethodLabels() { return DeliveryControlDrawMethodLabels; }
  public get MediaTypeSearchConvert() { return MediaTypeSearchConvert; }
  public get MediaType() { return MediaType; }
  public get MediaTypeLabels() { return MediaTypeLabels; }
  public get MediaTypeAppLabels() { return MediaTypeAppLabels; }
  public get MediaTypeSearchIndex() { return MediaTypeSearchIndex; }
  public get MediaTypeSearchLabels() { return MediaTypeSearchLabels; }
  public get AdFormatType() { return AdFormatType; }
  public get AdFormatTypeLabels() { return AdFormatTypeLabels; }
  public get Carrier() { return Carrier; }
  public get CarrierLabels() { return CarrierLabels; }
  public get PlatformPassbackID() { return PLATFORM_PASSBACK_ID; }
  public get PlatformDeliveryType() { return PlatformDeliveryType; }
  public get PlatformDeliveryTypeLabels() { return PlatformDeliveryTypeLabels; }
  public get FloorPriceOptimizeLabels() { return FloorPriceOptimizeLabels; }
  public get FloorPriceOptimize() { return FloorPriceOptimize; }
  public get EnableAutomaticRatio() { return EnableAutomaticRatio; }
  public get DesignTemplateType() { return DesignTemplateType; }
  public get DesignTemplateTypeLabels() { return DesignTemplateTypeLabels; }
  public get DesignTemplateAssetType() { return DesignTemplateAssetType; }
  public get DesignTemplateAssetTypeLabels() { return DesignTemplateAssetTypeLabels; }
  public get DesignTemplatePreviewModalReplaces() { return DesignTemplatePreviewModalReplaces; }
  public get DebugMode() { return DebugMode; }
  public get PlacementAssetType() { return PlacementAssetType; }
  public get PlacementAssetTypeLabels() { return PlacementAssetTypeLabels; }
  public get PlacementAssetTapType() { return PlacementAssetTapType; }
  public get PlacementAssetTapTypeLabels() { return PlacementAssetTapTypeLabels; }
  public get PlacementAssetDisplayType() { return PlacementAssetDisplayType; }
  public get PlacementAssetDisplayTypeLabels() { return PlacementAssetDisplayTypeLabels; }
  public get PlacementHasAsset() { return PlacementHasAsset; }
  public get Contents() { return Contents; }
  public get AccessPermission() { return AccessPermission; }
  public get OSGroupSetting() { return OSGroupSetting; }
  public get PlacementSearchMode() { return PlacementSearchMode; }
  public get SDKVersionGroupSetting() { return SDKVersionGroupSetting; }
  public get UserRoleCondition() { return UserRoleCondition; }
  public get UserRoleConditionLabels() { return UserRoleConditionLabels; }
  public get UserStatusCondition() { return UserStatusCondition; }
  public get UserStatusConditionLabels() { return UserStatusConditionLabels; }
  public get UserStatus() { return UserStatus; }
  public get NextAction() { return NextAction; }
  public get DeliveryScope() { return DeliveryScope; }
  public get DeliveryScopeLabels() { return DeliveryScopeLabels; }
  public get MaintenanceStatus() { return MaintenanceStatus; }
  public get MaintenanceStatusLabels() { return MaintenanceStatusLabels; }
  public get FloatingSettingSearchCode() { return FloatingSettingSearchType; }
  public get PlatformReservationStatus() { return PlatformReservationStatus; }
  public get CheckBoxPlatformDeliverType() { return CheckBoxPlatformDeliverType; }
  public get DeliverySetTesterCondition() { return DeliverySetTesterCondition; }
  public get DeliverySetTesterConditionLabels() { return DeliverySetTesterConditionLabels; }
}
